/* eslint-disable max-len */
import {
  ClaimType, ErrorCode, RAPolicyType,
} from '@constants';
import {
  setClaimInfo, setPackageList, clearSelectedItems, setRAReasonList, setUploadChosen,
} from '@store';
import { getPackage, getRAReason } from '@api';

export async function getRAReasonList(dispatch) {
  const { code, data } = await getRAReason();
  if (code === 0) {
    const list = data.map((item) => ({
      ...item,
      value: item.code,
      label: item.name,
    }));
    dispatch(setRAReasonList(list));
  }
}
// 根据接口返回判断是否需要显示options页面
export const useUrlJump = async (
  {
    policyList,
    navigate,
    dispatch,
    setIsInvalidBarShow,
  },
) => {
  const RAInfo = policyList.find((item) => RAPolicyType.includes(item.policyType));
  // 只有RA,直接到选择商品页
  if (RAInfo && policyList.length === 1) {
    const RA_POLICYID = policyList[0].policyId;
    dispatch(setClaimInfo({ type: ClaimType.RA, ...policyList[0] }));
    // const packageData = await getPackage(email, RA_POLICYID);
    // console.log('packageData', packageData.data);
    const resp = await getPackage(RA_POLICYID, ClaimType.RA);
    const { code, data } = resp;
    // console.log('ra packagedata', code);
    const errorMap = [ErrorCode.Expired, ErrorCode.Total, ErrorCode.Cancelled, ErrorCode.HasOldClaim, ErrorCode.CoverdItemEmpty];
    if (code === 0) {
      dispatch(setPackageList(data));
      navigate('/17track/choose');
      dispatch(clearSelectedItems());
      dispatch(setUploadChosen({ files: [], comments: '' }));
    } else if (errorMap.includes(code)) {
      navigate('/17track/error', { state: { code } });
    } else if (code === ErrorCode.Nothing) {
      const msg = 'No Seel covers found for this order. Please double check or contact support for help.';
      setIsInvalidBarShow({ show: true, message: msg });
    } else {
      navigate('/17track/error', { state: { code: ErrorCode.Wrong } });
    }
  } else {
    navigate('/17track/options');
  }
};
